<kiss-checkbox
  class="kiss-select__option__checkbox"
  tabindex="-1"
  [checked]="selected"
  [disabled]="disabled"
  *ngIf="multiple || showCheckbox"
></kiss-checkbox>
<ng-content></ng-content>
